import { render, staticRenderFns } from "./GeneralLedgerAccountShow.vue?vue&type=template&id=3a587b70&"
import script from "./GeneralLedgerAccountShow.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerAccountShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports